module.exports = __webpack_public_path__ + "img/own.c75bc288.png";